import _default from './MountNode';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/MountNode/index.js
// module id = 841
// module chunks = 0